import { memo, type ChangeEvent } from "react";
import InputAdornment, { type InputAdornmentProps } from '@mui/material/InputAdornment';
import Tooltip, { type TooltipProps } from "@mui/material/Tooltip";
import TextFieldLoadable from "./TextFieldLoadable";
import type { TextFieldLoadableProps } from "./types";

type Props = TextFieldLoadableProps & {
    readonly withValue?: (value: unknown) => string;
    readonly AdornmentProps?: {
        readonly TooltipProps?: TooltipProps;
        readonly InputAdornmentProps?: InputAdornmentProps;
    };
};

const AssetTextField = ({
    value,
    InputProps,
    AdornmentProps,
    withValue = value => String(value).replace(/^\//, ''),
    ...restProps
}: Props) => {
    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        event.target.value = withValue(event.target.value);

        return restProps.onChange?.(event);
    };

    return (
        <TextFieldLoadable
            {...restProps}
            value={withValue(value)}
            onChange={onChange}
            InputProps={{
                ...InputProps,
                startAdornment: (
                    <Tooltip
                        arrow
                        title={(
                            <>
                                Leading slash will be removed,<br />
                                but added back on save
                            </>
                        )}
                        placement='top'
                        {...AdornmentProps?.TooltipProps}
                    >
                        <InputAdornment
                            position='start'
                            {...AdornmentProps?.InputAdornmentProps}
                        >
                            {InputProps?.startAdornment ?? '/'}
                        </InputAdornment>
                    </Tooltip>
                )
            }}
        />
    );
};

export default memo(AssetTextField);
